import _ from 'lodash';

import createEnum from 'scripts/lib/create_enum';
import createModel, { prop } from './lib/create_model';
import IdGenerator from 'scripts/domain/contracts/id_generator';

export const ToastType = createEnum('ERROR', 'INFO', 'SUCCESS', 'WARN');

const Toast = createModel({
  modelName: 'Toast',
  properties: {
    id: prop(String),
    message: prop(String),
    link: prop(String),
    type: prop().oneOf(..._.values(ToastType)),
  },

  statics: {
    create(attrs) {
      return new this(_.merge({ id: IdGenerator.newId() }, attrs));
    },
  },
});

export default Toast;



// WEBPACK FOOTER //
// ./src/scripts/domain/models/toast.js